import { defineComponent as p, toRefs as f, ref as u, computed as w, resolveComponent as m, openBlock as t, createElementBlock as i, normalizeClass as y, createElementVNode as n, renderSlot as _, createVNode as h, createCommentVNode as v } from "vue";
import b from "../../atoms/VIcon/VIcon.js";
import { getComputedStyleValue as l } from "../../../utils/getComputedStyleValue.js";
import { _ as g } from "../../../_plugin-vue_export-helper-dad06003.js";
const C = p({
  name: "VNotification",
  components: { VIcon: b },
  props: {
    /**
     * type defines appearance of notification, different types are defined in type
     */
    type: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const { type: o } = f(e), r = u(!0);
    return {
      iconColor: w(() => o.value === "error" ? l("--tw-color-red") : o.value === "warning" ? l("--tw-color-yellow") : o.value === "info" ? l("--tw-color-blue") : o.value === "attention" ? l("--tw-color-orange") : o.value === "success" ? l("--tw-color-green") : ""),
      isDisplayed: r,
      closeNotification: () => {
        r.value = !1;
      }
    };
  }
});
const z = { class: "hobi-notification__icon hobi-notification__icon--state tw-flex tw-m-auto" }, N = ["aria-labelledby"], V = ["fill"], k = ["fill"], $ = ["fill"], I = ["fill"], M = { class: "hobi-notification__message tw-my-0 tw-mr-auto tw-ml-2" };
function B(e, o, r, a, s, S) {
  const c = m("VIcon");
  return e.isDisplayed ? (t(), i("div", {
    key: 0,
    class: y([
      "hobi-notification tw-bg-gray-200 tw-border-0 tw-border-l-8 tw-border-solid tw-text-gray-900 tw-text-sm tw-leading-5 tw-py-4 tw-pr-4 tw-pl-2 tw-flex tw-flex-row tw-justify-center tw-items-center",
      e.type === "error" ? "tw-border-red" : e.type === "warning" ? "tw-border-yellow" : e.type === "attention" ? "tw-border-orange" : e.type === "success" ? "tw-border-green" : "tw-border-blue"
    ])
  }, [
    n("div", z, [
      (t(), i("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        "aria-labelledby": e.type,
        role: "presentation"
      }, [
        e.type === "error" ? (t(), i("path", {
          key: 0,
          fill: e.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M19.074 4.927c-3.909-3.905-10.242-3.902-14.147.006-3.905 3.909-3.902 10.242.006 14.147 3.906 3.903 10.235 3.903 14.14 0 3.902-3.91 3.902-10.242 0-14.153zm-3.152 9.811a.834.834 0 0 1-1.175 1.18l-2.594-2.593a.21.21 0 0 0-.295 0l-2.593 2.594a.85.85 0 0 1-1.18 0 .834.834 0 0 1-.001-1.18l2.594-2.594a.208.208 0 0 0 .001-.293L8.084 9.257a.834.834 0 0 1 1.176-1.18l2.593 2.594a.208.208 0 0 0 .296 0l2.594-2.594a.834.834 0 0 1 1.179 1.18l-2.594 2.594a.209.209 0 0 0 0 .294l2.594 2.593z"
        }, null, 8, V)) : e.type === "warning" ? (t(), i("path", {
          key: 1,
          fill: e.iconColor,
          d: "M11.987 2.002a10.172 10.172 0 0 0-7.092 3.044 9.832 9.832 0 0 0-2.894 7.128A9.814 9.814 0 0 0 11.835 22h.178a10.093 10.093 0 0 0 9.988-10.173 9.803 9.803 0 0 0-10.014-9.825zm-1.236 13.784a1.23 1.23 0 0 1 1.208-1.275h.022a1.273 1.273 0 0 1 1.27 1.225 1.23 1.23 0 0 1-1.208 1.274h-.022a1.274 1.274 0 0 1-1.27-1.224zm.417-3.368v-5a.833.833 0 0 1 1.667 0v5a.833.833 0 1 1-1.667 0z"
        }, null, 8, k)) : e.type === "success" ? (t(), i("path", {
          key: 2,
          fill: e.iconColor,
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2-6.845 9.289c-.336.446-.97.535-1.416.199l-.014-.011-4.888-3.908a1 1 0 0 1 1.25-1.562l4.076 3.261 6.227-8.451a1 1 0 1 1 1.61 1.183z"
        }, null, 8, $)) : (t(), i("path", {
          key: 3,
          fill: e.iconColor,
          "clip-rule": "evenodd",
          d: "M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10-.006-5.52-4.48-9.994-10-10zm.208 4.167a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm1.875 11.25H10.75a.834.834 0 0 1 0-1.667h.625a.208.208 0 0 0 .208-.208v-3.75a.208.208 0 0 0-.208-.209h-.625a.834.834 0 0 1 0-1.666h.833c.921 0 1.667.745 1.667 1.666v3.959c0 .115.093.208.208.208h.625a.834.834 0 0 1 0 1.667z"
        }, null, 8, I))
      ], 8, N))
    ]),
    n("div", M, [
      _(e.$slots, "default", {}, void 0, !0)
    ]),
    n("div", {
      class: "hobi-notification__icon hobi-notification__icon--close tw-flex tw-cursor-pointer tw-ml-2",
      onClick: o[0] || (o[0] = (...d) => e.closeNotification && e.closeNotification(...d))
    }, [
      h(c, {
        symbol: "close",
        color: "black",
        size: "15"
      })
    ])
  ], 2)) : v("", !0);
}
const A = /* @__PURE__ */ g(C, [["render", B], ["__scopeId", "data-v-62319aa0"]]);
export {
  A as default
};
